import { useCallback } from "react";

import { useMarketingVoucherI18nFormModelContext } from "../../../../_context";

export const useVoucherI18nName = () => {
	const { viewModel, onSetViewModel } = useMarketingVoucherI18nFormModelContext();
	const { name } = viewModel;

	const onSetName = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "name", value: { ...name, value: input } }]);
		},
		[name, onSetViewModel],
	);

	return {
		name,
		onSetName,
	};
};
